import { render, staticRenderFns } from "./PreferencesMenu.vue?vue&type=template&id=b93b0878&"
import script from "./PreferencesMenu.vue?vue&type=script&lang=js&"
export * from "./PreferencesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b93b0878')) {
      api.createRecord('b93b0878', component.options)
    } else {
      api.reload('b93b0878', component.options)
    }
    module.hot.accept("./PreferencesMenu.vue?vue&type=template&id=b93b0878&", function () {
      api.rerender('b93b0878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/PreferencesMenu.vue"
export default component.exports